import { render, staticRenderFns } from "./VotingStandardTable.vue?vue&type=template&id=0b17c8e0"
import script from "./VotingStandardTable.vue?vue&type=script&lang=js"
export * from "./VotingStandardTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports